// Initialize sentry
import('./sentry');

// initialize inlined service URLs
const serviceUrlsElement = document.getElementById('_id_veo_service_urls');
if (serviceUrlsElement) {
  try {
    window.VEO_SERVICE_URLS = JSON.parse(serviceUrlsElement.textContent);
  } catch {}
}

// load waffle features
const loadWaffleFeatures = async () => {
  let API_BASE_URL = (
    window.VEO_SERVICE_URLS?.API_APP_URL || `${process.env.REACT_APP_SERVER_URL}/api/app/`
  );
  if (API_BASE_URL.charAt(API_BASE_URL.length - 1) === '/') {
    // remove appending slash
    API_BASE_URL = API_BASE_URL.substring(0, API_BASE_URL.length - 1);
  }
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  let auth_token = null;
  try {
    auth_token = localStorage.getItem('auth_token');
  } catch (error) {}

  if (auth_token) {
    headers.append('Authorization', `Bearer ${auth_token}`);
  }
  const response = await fetch(
    `${API_BASE_URL}/auth/waffle-json/`,
    { headers, credentials: 'include' }
  );
  global.waffle = response.status === 200 ? await response.json() : {};
};

// make available globally (for the app)
window.loadWaffleFeatures = loadWaffleFeatures;


// initialize app once all requirements are met
loadWaffleFeatures().then(() => {
  import('./bootstrap');
});

